"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FORMAT_ID_BYTES = exports.DIVVI_MAGIC_PREFIX = void 0;
// Magic prefix is keccak256("divvi").slice(2, 10)
exports.DIVVI_MAGIC_PREFIX = '6decb85d';
/**
 * Maps format IDs to their byte representations.
 * Each format ID is represented as a 2-character hex string (1 byte).
 */
exports.FORMAT_ID_BYTES = {
    default: '00',
};
//# sourceMappingURL=constants.js.map